<template>
  <div class="div-category-selectables-base">
    <div class="div-category-selectables-heading">
      <div class="div-category-selectables-icon">
        <img
          id="img-category-selectables-content"
          src="@/assets/docrates-icon-health-and-welfare.svg"
        />
      </div>
      <h2
        id="category-selectables-h2"
        v-html="
          store.getters.translate(
            'category-services-appointment-health-and-welfare-heading'
          )
        "
      ></h2>
    </div>
    <div class="div-category-selectables-content">
      <category-service-card
        @selected="serviceSelectedInComponent"
        categoryServiceType="physiotherapy"
        :heading="
          store.getters.translate('category-service-card-physiotherapy-heading')
        "
        :text-1="
          store.getters.translate('category-service-card-physiotherapy-text-1')
        "
      ></category-service-card>
      <category-service-card
        @selected="serviceSelectedInComponent"
        categoryServiceType="sexual-counseling"
        :heading="
          store.getters.translate(
            'category-service-card-sexual-counseling-heading'
          )
        "
        :text-1="
          store.getters.translate(
            'category-service-card-sexual-counseling-text-1'
          )
        "
      ></category-service-card>
      <category-service-card
        @selected="serviceSelectedInComponent"
        categoryServiceType="urotherapy"
        :heading="
          store.getters.translate('category-service-card-urotherapy-heading')
        "
        :text-1="
          store.getters.translate('category-service-card-urotherapy-text-1')
        "
      ></category-service-card>
      <category-service-card
        @selected="serviceSelectedInComponent"
        categoryServiceType="psychology"
        :heading="
          store.getters.translate('category-service-card-psychology-heading')
        "
        :text-1="
          store.getters.translate('category-service-card-psychology-text-1')
        "
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { index } from "@/store/index";
import CategoryServiceCard from "@/components/CategoryServiceCard.vue";
import { getServiceTypeFromString } from "@/store/appointment-selection";

export default defineComponent({
  components: { CategoryServiceCard },
  name: "CategoryServiceHealthAndWelfare",
  emits: ["serviceSelected"],
  data() {
    return {
      store: index
    };
  },
  methods: {
    serviceSelectedInComponent(selectedServiceType: string) {
      this.$emit(
        "serviceSelected",
        getServiceTypeFromString(selectedServiceType)
      );
    }
  }
});
</script>

<style scoped lang="scss">
.div-category-selectables-icon {
  padding-left: 9px;
  padding-top: 13px;
  position: static;
  width: 60px;
  height: 60px;
  border: 1px solid $original;
  box-sizing: border-box;
  border-radius: 161px;
  margin-right: 20px;
  min-width: 60px;
}
h2 {
  margin-top: 10px;
}
</style>
